import React, { useContext, useEffect, useState } from "react";
import "./Login.css";
import axios from "../axios/axios";
import Context from "../../Context/Context";
import { useNavigate } from "react-router-dom";
import { IoEyeSharp } from "react-icons/io5";
import { FaEyeSlash } from "react-icons/fa";
import NotificacaoDeErro from "../Notificacao/NotificacaDeErro";

const Login = () => {
  const [msn, setMsn] = useState("");
  const [mostrarNotificacaoDeErro, setMostrarNotificacaoDeErro] =
    useState(false);

  const [formData, setFormData] = useState({
    email: "",
    senha: "",
  });
  const navigate = useNavigate();
  const { usuario, setUsuario } = useContext(Context);
  useEffect(() => {
    if (usuario != null) {
      navigate("/home");
    }
  }, []);
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    try {
      console.log(formData);
      const { data } = await axios.post("/user/login", formData);
      setUsuario(data);
      navigate("/home");
    } catch (error) {
      setMsn("Usuario não encontrado");
      setMostrarNotificacaoDeErro(true);
    }
    // setUsuario (Context)
  };
  return (
    <div className="conteiner-principal">
      <div className="card-conteiner">
        <div className="card-left">
          <form onSubmit={handleSubmit} className="flex gap-5 flex-col">
            <div className="">
              <label
                htmlFor="email"
                className="tracking-wide block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                E-mail:
              </label>
              <div className="flex w-full h-11">
                {" "}
                {/* Define altura fixa */}
                <span className="inline-flex items-center justify-center px-3 text-sm text-gray-900 bg-gray-200 border border-e-0 border-gray-300 rounded-s-md dark:bg-gray-600 dark:text-gray-400 dark:border-gray-600 h-full">
                  <svg
                    className="w-5 h-5 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M2 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v.5L10 11 2 5.5V5Zm0 2.236V15a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.236l-8 5.6-8-5.6Z" />
                  </svg>
                </span>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="h-full block w-full text-sm text-gray-900 bg-gray-50 border border-gray-300 rounded-none rounded-r-md focus:ring-blue-500 focus:border-blue-500 px-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="seuemail@exemplo.com"
                />
              </div>
            </div>
            <div className="form-login">
              {/* <label>Senha:</label>
                            <div className="password-container">
                                <input
                                    type={mostrarSenha ? "text" : "password"}
                                    name="senha"
                                    value={formData.senha}
                                    onChange={handleChange}
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => setMostrarSenha((prev) => !prev)}
                                    className="toggle-password"
                                >
                                    {mostrarSenha ? <IoEyeSharp />: <FaEyeSlash /> }
                                </button>
                            </div> */}

              <label
                htmlFor="password"
                className="tracking-wide block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Senha:
              </label>

              <div className="flex w-full h-11 relative">
                {" "}
                {/* Define altura fixa */}
                <span className="inline-flex items-center justify-center px-3 text-sm text-gray-900 bg-gray-200 border border-e-0 border-gray-300 rounded-s-md dark:bg-gray-600 dark:text-gray-400 dark:border-gray-600 h-full">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z"
                    />
                  </svg>
                </span>
                <input
                  type={mostrarSenha ? "text" : "password"}
                  id="password"
                  name="senha"
                  value={formData.senha}
                  onChange={handleChange}
                  required
                  className="h-full block w-full text-sm text-gray-900 bg-gray-50 border border-gray-300 rounded-none rounded-r-md focus:ring-blue-500 focus:border-blue-500 px-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="senha"
                />
                <button
                  className="hover:!bg-transparent absolute right-0 mr-2 top-3"
                  type="button"
                >
                  {mostrarSenha ? (
                    <IoEyeSharp onClick={() => setMostrarSenha(false)} />
                  ) : (
                    <FaEyeSlash onClick={() => setMostrarSenha(true)} />
                  )}
                </button>
              </div>
            </div>
            <button className="w-[100%] bg-black text-white py-2 mt-5">
              Entrar
            </button>
            <NotificacaoDeErro
              mostrar={mostrarNotificacaoDeErro}
              onClose={() => setMostrarNotificacaoDeErro(false)}
              mensagem={msn}
            />
          </form>
        </div>
        <div className="card-right">
          <img src="/logo.jpg" alt="Logo" className="logo" />
          {/* <h2>Bem-vindo de volta!</h2>
                    <p>Estamos felizes em vê-lo novamente.</p>
                    <p>Por favor, faça login para continuar.</p> */}
        </div>
      </div>
    </div>
  );
};
export default Login;
